module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Dvd1 SitePage Search */

(function(fox) {
	fox.registerWidget('SitePage_Splash', {
		
		configure: function(options) {
			this.registerOptions('', {
				'handleDom.enterSite': {
					event: 'click',
					target: '.enter',
					callback: this.enterSite
				}
			});

			this.callParent('configure', arguments);
		},

		enterSite: function(){
			var retUrl = fox.Navigator.get(0);
			fox.cookie.set('splash', 1);
			fox.site.showSplash = false;
			fox.site.runPage(retUrl !== 'splash' ? retUrl : 'home', {skipEvent: true});
		}

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/sitepage/splash.js
// module id = 137
// module chunks = 4